import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormArray, Validators, AbstractControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HoverMenuDirective } from '@fuse/directives/hover-menu/hover-menu.directive';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { getCode } from 'app/utils/method';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ExpenseReasonService } from './expense-reason.service';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import ExpenseReasonAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/expense-reason/expense-reason.entity';
import { MatDividerModule } from '@angular/material/divider';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { RoutesFiltersComponent } from '../../filters/routes-filters/routes-filters.component';
import RouteAttributes from '@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity';
import { SubRouteService } from '../../routing/sub-routes/sub-route.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { status } from 'app/layout/export-overlay/tasks/core/processors/types/ave/ave-types';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';

@Component({
  selector: 'app-expense-reason',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    FilterSectionComponent,
    HoverMenuDirective,
    MatDividerModule,
    NgxMatSelectSearchModule,
    RoutesFiltersComponent,
    CompanyCurrencyPipe
  ],
  templateUrl: './expense-reason.component.html',
  styleUrl: './expense-reason.component.scss'
})

export class ExpenseReasonComponent {
  getCode = getCode;
  displayedColumns: string[] = ["name", "amount", "photographRequired", "observationRequired", "status", "actions"];
  displayedColumnSalesOffice: string[] = ["salesOffice", "account", "costCenter", "postingKey", "actions"];

  dataSource: ExpenseReasonAttributes[] = [];

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  searchSubscription: Subscription;

  createForm: FormGroup;

  updateForm: FormGroup;

  salesOfficeList: SalesOfficeAttributes[] = []

  routeList: RouteAttributes[] = []
  filteredRouteList: RouteAttributes[] = [];

  routeSearch: string = "";

  dataSourceSalesOffice = new MatTableDataSource<FormGroup>([]);
  dataSourceUpdateSalesOffice = new MatTableDataSource<AbstractControl>([]);

  selectedStatuses: number [] = [];

  formFilter: FormGroup;
  
  loadRoutesData = false;

  constructor(
    private readonly expenseReasonService: ExpenseReasonService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly routeService: SubRouteService
  ) {
    this.createForm = this.fb.group({
      name: [],
      maximumAmountAllowed: [0],
      photographRequired: [false],
      observationRequired: [false],
      allSalesOffices: [false],
      salesOffices: this.fb.array([]),
      allSubRoutesBySalesOffices: [false],
      subRoutesBySalesOffices: [[]],
      statusId: 1
    });

    this.updateForm = this.fb.group({
      name: [],
      _id: ['', Validators.required],
      maximumAmountAllowed: [0],
      photographRequired: [false],
      observationRequired: [false],
      allSalesOffices: [false],
      salesOffices: this.fb.array([]),
      allSubRoutesBySalesOffices: [false],
      subRoutesBySalesOffices: [[]],
      statusId: []
    });

    this.formFilter = this.fb.group({
      subRouteId: []
    });

    this.updateDataSource();
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.fetchAllSalesOfficeInit();
    this.fetchAllRoute();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private fetchAllRoute(): void {
    this.routeService
      .findToComboBox()
      .subscribe({
        next: (res) => {
          this.routeList = res.data;
          this.filteredRouteList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener rutas.", "Cerrar", { duration: 5000 });
        },
      });
  }

  filteredRoutesList(search: string) {
    if (!search) {
      this.filteredRouteList = this.routeList;
      return;
    }
    const filterValue = search.toLowerCase();
    this.filteredRouteList = this.routeList.filter(t =>
      t.name.toLowerCase().includes(filterValue) ||
      (t.externalKeys?.code?.toLowerCase().includes(filterValue))
    );
  }

  getDisplayValueForMongoId(
    list: ({ _id: string })[],
    ids: string[],
    field1: string,
    field2?: string
  ): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id))
        .map(item => {
          let result = this.getNestedProperty(item, field1) ?? '';
          if (field2) {
            const second = this.getNestedProperty(item, field2);
            if (second) {
              result += '-' + second;
            }
          }
          return result.trim();
        })
        .join(', ');
    } else {
      const found = list.find(item => item._id === ids);
      if (!found) return '';
      let result = this.getNestedProperty(found, field1) ?? '';
      if (field2) {
        const second = this.getNestedProperty(found, field2);
        if (second) {
          result += '-' + second;
        }
      }
      return result.trim();
    }
  }

  getNestedProperty(obj, path: string) {
    path = path.replace(/\[(\w+)\]/g, '.$1');
    const keys = path.split('.');
    let result = obj;
    for (const key of keys) {
      if (result == null) return undefined;
      result = result[key];
    }
    return result;
  }

  private fetchAllSalesOfficeInit(): void {
    this.salesOfficeService
      .findToComboBox()
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error fetching sales opfice.", "Cerrar", { duration: 5000 });
        },
      });
  }

  clearFilters(): void {
    this.searchQuery = "";
    this.formFilter.reset();
    this.findAllWithCount();
  }

  applyStatusFilter(): void {
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }

  get salesOfficesArray(): FormArray {
    return this.createForm.get('salesOffices') as FormArray;
  }

  private createSaleOfficeRow(initialData?): FormGroup {
    return this.fb.group({
      salesOfficesId: [initialData?.salesOfficesId || ''],
      account: [initialData?.account || ''],
      costCenter: [initialData?.costCenter || ''],
      postingKey: [initialData?.postingKey || ''],
    });
  }

  private deleteDataSource(): void {
    while (this.salesOfficesArray.length) {
        this.salesOfficesArray.removeAt(0);
    }
    this.updateDataSource();
  }

  private updateDataSource(): void {
        this.dataSourceSalesOffice.data = this.salesOfficesArray.controls as FormGroup[];
    }

  addSaleOfficeRow(): void {
    this.salesOfficesArray.push(this.createSaleOfficeRow());
    this.updateDataSource();
}

  removeSaleOfficeRow(index: number): void {
    this.salesOfficesArray.removeAt(index);
    this.updateDataSource();
  }

  onPhotoChange(event: boolean, expense: ExpenseReasonAttributes): void {
    const photographRequired = expense.photographRequired;
    const updatedPhotographRequired = event ? true : false;
    const updatedExpense: ExpenseReasonAttributes = { ...expense, photographRequired: updatedPhotographRequired };

    this.expenseReasonService
      .update(expense._id.toString(), updatedExpense)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          expense.photographRequired = photographRequired;
          this.snackBar.open("Error al actualizar el si requiere foto.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  onObservationChange(event: boolean, expense: ExpenseReasonAttributes): void {
    const observationRequired = expense.observationRequired;
    const updatedObservationRequired = event ? true : false;
    const updatedExpense: ExpenseReasonAttributes = { ...expense, observationRequired: updatedObservationRequired };

    this.expenseReasonService
      .update(expense._id.toString(), updatedExpense)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          expense.photographRequired = observationRequired;
          this.snackBar.open("Error al actualizar el si requiere foto.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  onStatusChange(event: boolean, expense: ExpenseReasonAttributes): void {
    const statusId = expense.statusId;
    const updatedStatusId= event ? 1 : 0;
    const updatedExpense: ExpenseReasonAttributes = { ...expense, statusId: updatedStatusId };

    this.expenseReasonService
      .update(expense._id.toString(), updatedExpense)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          expense.statusId = statusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  update(): void {
    if(!this.updateForm.get("allSalesOffices").value && this.updateForm.get("salesOffices").value.length === 0){
      this.snackBar.open("Tiene que agrear una oficina de venta especifica.", "Cerrar", {
          duration: 3000,
        });
        return;
    }

    if(!this.updateForm.get("allSubRoutesBySalesOffices").value && this.updateForm.get("subRoutesBySalesOffices").value.length === 0){
      this.snackBar.open("Tiene que agrear una ruta especifica..", "Cerrar", {
          duration: 3000,
        });
        return;
    }

    if(this.updateForm.get("allSubRoutesBySalesOffices").value){
      this.updateForm.get("subRoutesBySalesOffices").setValue([]);
    }

    if(this.updateForm.get("allSalesOffices").value){
      while (this.updateSalesOfficesArray.length) {
        this.updateSalesOfficesArray.removeAt(0);
      }
    }

    if (this.updateForm.invalid) {
      this.snackBar.open("El formulario de edición contiene errores o campos incompletos.", "Cerrar", {
        duration: 3000,
      });
      this.updateForm.markAllAsTouched();
      return;
    }

    const expenseId = this.updateForm.get("_id")!.value;

    this.expenseReasonService
      .update(expenseId, this.updateForm.value)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(err.error?.message || "Error al actualizar registro.", "Cerrar", {
            duration: 5000,
          });
        },
      });
  }

  openCreateModal(): void {
    this.createForm.reset({
      name: [],
      maximumAmountAllowed: 0,
      photographRequired: false,
      observationRequired: false,
      allSalesOffices: false,
      allSubRoutesBySalesOffices: false,
      subRoutesBySalesOffices: [],
      statusId: 1
    });

    while (this.salesOfficesArray.length) {
      this.salesOfficesArray.removeAt(0);
    }

    this.updateDataSource();

    this.dialogRefAdd = this.dialog.open(this.addModal, { disableClose: true, width: '90%' });
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  get updateSalesOfficesArray(): FormArray {
    return this.updateForm.get('salesOffices') as FormArray;
  }

  private updateDataSourceUpdate(): void {
    this.dataSourceUpdateSalesOffice.data = this.updateSalesOfficesArray.controls;
    this.cdr.detectChanges();
}

  addSaleOfficeRowToUpdate(): void {
    this.updateSalesOfficesArray.push(this.createSaleOfficeRow());
    this.updateDataSourceUpdate();
  }
  removeSaleOfficeRowToUpdate(index: number): void {
    this.updateSalesOfficesArray.removeAt(index);
    this.updateDataSourceUpdate();
  }

  openEditModal(expense: ExpenseReasonAttributes): void {
    while (this.updateSalesOfficesArray.length) {
      this.updateSalesOfficesArray.removeAt(0);
    }

    expense.salesOffices.forEach(so => {
      this.updateSalesOfficesArray.push(this.createSaleOfficeRow(so));
    });

    this.updateDataSourceUpdate();

    const selectedSubRoutesBySalesOffices = expense?.subRoutesBySalesOffices.map((item) => item);

    this.updateForm.patchValue({
      name: expense.name,
      _id: expense._id,
      maximumAmountAllowed: expense.maximumAmountAllowed,
      photographRequired: expense.photographRequired,
      observationRequired: expense.observationRequired,
      allSalesOffices: expense.allSalesOffices,
      allSubRoutesBySalesOffices: expense.allSubRoutesBySalesOffices,
      subRoutesBySalesOffices: selectedSubRoutesBySalesOffices,
      statusId: expense.statusId
    });

    this.dialogRefEdit = this.dialog.open(this.editModal, { disableClose: true, width: '90%' })
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  openDeleteDialog(condition: ExpenseReasonAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  createExpenseReason(): void {
    if(!this.createForm.get("allSalesOffices").value && this.createForm.get("salesOffices").value.length === 0){
      this.snackBar.open("Tiene que agrear una oficina de venta especifica.", "Cerrar", {
          duration: 3000,
        });
        return;
    }

    if(!this.createForm.get("allSubRoutesBySalesOffices").value && this.createForm.get("subRoutesBySalesOffices").value.length === 0){
      this.snackBar.open("Tiene que agrear una ruta especifica..", "Cerrar", {
          duration: 3000,
        });
        return;
    }

    if(this.createForm.get("allSubRoutesBySalesOffices").value){
      this.createForm.get("subRoutesBySalesOffices").setValue([]);
    }

    if(this.createForm.get("allSalesOffices").value){
      this.createForm.get("salesOffices").setValue([]);
    }

    this.expenseReasonService.create(this.createForm.value).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.createForm.reset();
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(
          err.message.message || "Error al crear el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  delete(id: string): void {
    this.expenseReasonService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    const dataFilter: IFilters = {
      subRouteId: this.formFilter.get("subRouteId")?.value,
      status: this.selectedStatuses
    }

    this.expenseReasonService
      .findAllWithCount({
        currentPage: pageIndex,
        limitPerPage: this.pageSize,
        search: this.searchQuery,
        sort: sortField,
        sortDirection: sortDirection,
      },
      dataFilter)
      .subscribe((data) => {
        this.dataSource = data?.data?.data ?? [];
        this.totalItems = data?.data?.pageInfo?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof ExpenseReasonAttributes {
    const validSortFields: (keyof ExpenseReasonAttributes)[] = [
      "createdAt",
      "maximumAmountAllowed",
    ];
    return validSortFields.includes(
      this.sort.active as keyof ExpenseReasonAttributes
    )
      ? (this.sort.active as keyof ExpenseReasonAttributes)
      : "createdAt";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  trackByFn(index: number, item: ExpenseReasonAttributes): string {
    return item._id.toString();
  }
}
